import React, { useMemo, useState } from 'react';
import Classes from './RecordTable.module.css';
import useScreenWidth from '../../../../../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';
import { AddIcon } from '../../../../../../../../../utils/Icons';

export default function RecordTable({ bookingId, rows = [], loading = false }) {
  const navigateTo = useNavigate();
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= 480;

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.max(1, Math.ceil(rows.length / itemsPerPage));
  const currentItems = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return rows.slice(start, start + itemsPerPage);
  }, [rows, currentPage]);

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, rows.length);
  const totalItems = rows.length;

  function handlePageChange(_e, pageNum) {
    setCurrentPage(pageNum);
  }

  return (
    <div className={Classes.hero}>
      <div className={Classes.table}>
        <div className={Classes.tableWrapper}>

          <div className={Classes.tableHeader}>
            <div className={`${Classes.headerItem} ${Classes.header1}`}>
              <h5>Number</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header3}`}>
              <h5>Status</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header4}`}>
              <h5>Total</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header5}`}>
              <h5>Created</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header6}`}>
              <h5>Paid</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header7}`}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {/* Route of your choice; booking-aware for prefill */}
                <button className={Classes.addBtn} onClick={() => navigateTo(`/add-invoice/${bookingId}`)}>
                  <AddIcon height='12px' fill='white' />
                  <h5>Add invoice</h5>
                </button>
              </div>
            </div>
          </div>

          <div className={Classes.tableBody}>
            {loading ? (
              <SkeletonLoading
                length={itemsPerPage}
                height={isMobile ? '3.5rem' : '2.8rem'}
                width="100%"
                br="6px"
                padding='0'
              />
            ) : currentItems && currentItems.length > 0 ? (
              currentItems.map((row, idx) => (
                <TableRow key={row._id || idx} value={row} index={idx} />
              ))
            ) : (
              <h5 className='placeholderText' style={{ margin: '10px 19px' }} >No invoices yet...</h5>
            )}
          </div>

          {currentItems && currentItems.length > 0 &&
            <div className={Classes.pagFooter}>
              <h5 style={{ height: '1.2rem' }}>
                {loading
                  ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                  : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                }
              </h5>
              <Stack spacing={2} className={Classes.pagination}>
                {loading
                  ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                  : <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    shape="rounded"
                  />
                }
              </Stack>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
